// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gEk3_{grid-column:auto/span var(--cellWidth, 12)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `gEk3_`
};
export default ___CSS_LOADER_EXPORT___;
